import React from 'react';
import { useValidateImageURL } from 'use-validate-image-url';
// import DefaultSvgIcon from '../icons/DefaultSvgIcon';
import './CustomImage.scss';
import PlaceholderImageIcon from './PlaceHolderImageIcon';

const CustomImage = ({ alt = 'alt', className, ...props }) => {
  const status = useValidateImageURL(props?.src || '');
  const [didMount, setDidMount] = React.useState(false);

  React.useEffect(() => {
    setDidMount(true);
    return () => setDidMount(false);
  }, []);
  const renderImg = () => {
    // if (status === 'progress') return <DefaultSvgIcon />;
    // if (status === 'invalid') return <DefaultSvgIcon />;
    if (status === 'progress')
      return (
        <div className={`custom-image ${className || ''}`}>
          <PlaceholderImageIcon />
        </div>
      );
    if (status === 'invalid')
      return (
        <div className={`custom-image ${className || ''}`}>
          <PlaceholderImageIcon />
        </div>
      );
    else if (status === 'valid')
      return (
        <div className={`${className || ''}`}>
          <img style={props?.style} src={props?.src || ''} alt={alt} />
        </div>
      );
    return null;
  };

  if (!didMount) {
    return null;
  }

  return renderImg();
};

export default CustomImage;
